module.exports = "<div class=\"processing-simulation text-center\">\r\n  Processando...\r\n</div>"